import '../../../scss/blocks/custom/block-testimonials.scss';
import '../../../../blocks/block-testimonials/script';
